import { en } from "./en";

export const zh: typeof en = {
  languages: {
    de: "De",
    en: "En",
    zh: "中文",
    pt: "Pt",
    fr: "Fr",
  },
  seoDefaults: {
    albis: {
      title: "ALBIS - 简单、智能、充满激情。",
      brandPrefix: "ALBIS - ",
      description:
        "聚合物分销。塑料相关所有事务的技术专家和顾问。全球最广泛的产品组合之一。",
    },
    mocom: {
      title: "MOCOM - 卓越复合。",
      brandPrefix: "MOCOM - ",
      description: "聚合物复合。",
    },
    krahnCeramics: {
      title: "KRAHN陶瓷 - 陶瓷和金属粉末加工创新项目合作伙伴",
      brandPrefix: "KRAHN CERAMICS - ",
      description:
        "作为陶瓷和金属领域经验丰富的技术合作伙伴，我们陪伴产品开发者在整个价值链中实现明天的创意：从陶瓷或金属粉末到成品零件的生产。",
    },
    ottoKrahnGroup: {
      title: "奥托·克拉恩集团 – 重新定义。",
      brandPrefix: "Otto Krahn Group - ",
      description:
        "年来您值得信赖的塑料和化学品合作伙伴拥有全新架构：ALBIS、KRAHN、MOCOM、WIPAG统一于新的控股公司。",
    },
    htf: {
      title: "KRAHN传热流体 - 伊士曼官方合作伙伴",
      brandPrefix: "KRAHN Heat Transfer Fluids - ",
      description:
        "从Therminol®/Marlotherm™产品组合中选择合适的传热流体。提供加热器、泵和废气技术的全面咨询。",
    },
    wipag: {
      title: "WIPAG",
      brandPrefix: "WIPAG - ",
      description: "塑料加工复合材料生产和个性化循环经济概念实施专家。",
    },
    plgrd: {
      title: "游乐场",
      brandPrefix: "Playground - ",
      description: "与地面互动游戏",
    },
    krahnChemie: {
      title: "KRAHN化学",
      brandPrefix: "KRAHN Chemie - ",
      description: "KRAHN化学",
    },
    okNewBusiness: {
      title: "奥托·克拉恩新业务",
      brandPrefix: "Otto Krahn New Business",
      description: "奥托·克拉恩新业务",
    },
  },
  header: {
    contact: "联系我们",
    outline: "概览",
  },
  search: {
    search: "搜索",
    label: "搜索",
    lastSearches: "您最近的搜索",
    directEnter: "快速入口",
    files: "文件",
    stories: "文章",
    pages: "页面",
    products: "产品",
    press: "新闻稿",
    industries: "行业",
    results: "的搜索结果",
    more: "显示更多",
    noResults: "没有找到",
    adjustSearch: "请调整您的搜索条件并重试。",
    download: "下载",
    short: "您的搜索词太短。",
    entrances: {
      albis: [
        {
          link: "/zh/products/product-search/",
          label: "数据表",
        },
        {
          link: "/zh/services/quality-management",
          label: "证书",
        },
        {
          link: "/zh/products/brochures",
          label: "安全数据表",
        },
      ],
      wipag: [
        {
          link: "/zh/downloads",
          label: "下载和证书",
        },
      ],
      mocom: [
        {
          link: "/zh/products/product-search#/",
          label: "数据表",
        },
        {
          link: "/zh/downloads",
          label: "安全数据表和证书",
        },
      ],
      ottoKrahnGroup: [{ link: "/zh/brands", label: "品牌" }],
      krahnChemie: [{ link: "/zh/markets", label: "市场" }],
    },
  },
  products: {
    viewProduct: "查看产品",
    back: "返回概览",
  },
  newsletter: {
    mandatory: "* 必填项",
  },
  contact: {
    phone: "电话：",
    fax: "传真：",
    email: "邮箱：",
    writeEMail: "发送邮件",
    form: {
      button: "提交",
      send: "发送",
      placeholder: {
        email: "邮箱",
        name: "姓名",
        company: "公司（可选）",
        companyReq: "公司",
        subject: "主题",
        street: "街道",
        apartmentNumber: "门牌号",
        plz: "邮政编码",
        city: "城市",
        message: "描述您的挑战：",
        country: "国家",
        startup: "公司",
        comment: "评论",
        phone: "电话",
      },
      label: {
        message: "您的消息",
      },
      success: "谢谢！您的消息已发送。",
      error: "发生错误。请稍后重试或通过info@albis.com联系我们。",
    },
  },
  contactFinder: {
    title: "您的联系人",
    description:
      "为了帮助我们更好地回答您的问题，请在此输入您的位置和邮政编码。然后将显示相应的联系人。",
    findAction: "查找",
    zipCodeLabel: "邮政编码",
    countryLabel: "选择国家",
    contactPersonTitle: "联系人",
    warningMessage: "很抱歉，我们找不到联系人。请检查您输入的国家和邮政编码。",
    contactButton: "请求联系",
  },
  contactFinderV2: {
    countryLabel: "选择国家",
    loadingText: "正在加载...",
  },
  contactDialog: {
    title: "请求联系",
    contactByPhoneActionLabel: "请用以下电话号码回电给我：",
    dataProtectionConsentActionLabel:
      "我同意<a href='{{link}}' target='_blank'>数据隐私政策</a>。",
    requestMsgLabel: "告诉我们您的请求原因",
    submit: "发送消息",
    requestMessage: "在此输入",
    successTitle: "我们会联系您",
    successDescription: "您的请求已成功提交。我们会尽快联系您。",
    errorDescription: "出现错误。",
    successBtnLabel: "返回页面",
  },
  media: {
    press: {
      categories: {
        products: "产品",
        company: "公司",
        "shows-and-events": "展会与活动",
        "healthcare-solutions": "医疗解决方案",
        extrusion: "挤出",
        "smart-plastics-at-home": "智能塑料@家庭",
        sustainability: "可持续发展",
        "markets-industry": "市场 / 行业",
        "success-story": "成功案例",
        "expert-article": "专家文章",
        events: "活动",
      },
      loadMore: "加载更多",
    },
    events: {
      addToCalendar: "添加到日历",
    },
    filter: {
      year: "发布年份",
      topic: "主题",
    },
    noResults: "暂无条目",
  },
  markets: {
    cases: "案例研究",
    productInformation: "产品信息",
    categories: {
      interior: "内饰",
      exterior: "外饰",
      "under-the-hood": "发动机舱",
      outdoor: "园艺工具",
      hvac: "暖通空调",
      furniture: "家具",
      kitchenware: "小家电和家居用品",
      sanitary: "卫浴",
      tools: "电动工具",
      wintersports: "山地和冬季运动",
      sportswear: "运动服装",
      marine: "水上运动",
      materials: "材料",
      vehicles: "车辆",
      trains: "火车",
      digger: "挖掘机",
      solar: "可再生能源",
      radio: "无线电",
      video: "安全防护系统",
      computer: "大型家电",
      lights: "照明技术",
      electricity: "电气安装",
      machine: "机械",
      robots: "机器人",
      aircondition: "空调",
      safety: "安全",
      monitors: "监视器",
      controlling: "控制",
      tubes: "管道",
      bedside: "床边材料",
      packaging: "包装",
      bicycle: "自行车运动",
      household: "家庭用品",
      "post-industrial": "工业后回收",
      renewable: "可再生能源",
      mechanical: "机械回收",
      energy: "能源回收",
      biobased: "生物基资源",
      "post-consumer": "消费后回收",
      diagnostic: "体外诊断、实验室用品和生物科学",
      infusion: "医疗器械 - 输液系统",
      "drug-delivery": "医疗器械 - 给药系统",
      monitoring: "医疗器械 - 重症监护和患者监测",
      "medical-packaging": "药品和医疗器械包装",
      "medical-devices":
        "其他医疗器械 - 外科、康复、献血、疫苗接种应用领域（示例）",
    },
  },
  okg: {
    jobTeaser: {
      student: "学生",
      graduate: "毕业生",
      youngprofessional: "年轻专业人士",
      professional: "专业人士",
    },
    pressTeaser: {
      news: "新闻",
      readMore: "完整文章",
    },
    privacy: "隐私政策",
  },
  htf: {
    tempRange: "温度范围：",
    modeDetails: "更多详情",
    close: "关闭",
    searchPlaceholder: "搜索产品",
    typicalApplication: "典型应用",
    descriptionOfServices: "服务描述",
    productData: "产品数据",
    thermometerDescription: "请移动调节器以筛选产品。",
    thermometerMinLabel: "最低温度 (°C)",
    thermometerMaxLabel: "最高温度 (°C)",
    resetFilter: "重置筛选",
    filter: "筛选",
    tempRangeFormat: "#t1#° 至 #t2#°C",
    productInformation: {
      tempRange: "温度范围",
      optimalUsageTemp: "最佳使用温度",
      maxBulkTemp: "推荐体积温度 °C",
      maxExtendedBulkTemp: "最高延长体积温度 °C",
      maxFilmTemp: "最高薄膜温度 °C",
      boilingPoint: "沸点 °C @ 1013 mbar",
      pumpability: "可泵性 °C @ 300 mm²/s (cSt)",
      pourPoint: "倾点 °C",
      crystallizingPoint: "结晶点 °C",
      slurryPoint: "浆体点 °C",
      flashPointD93: "闪点 °C (ASTM D93)",
      flashPointD92: "闪点 °C (ASTM D92)",
      autoignitionTempDIN51794: "自燃温度 °C (DIN 51794)",
      autoignitionTempASTME659: "自燃温度 °C (ASTM E-659)",
      density20: "密度 @ 20°C (kg/m³)",
      density25: "密度 @ 25°C (kg/m³)",
      density80: "密度 @ 80°C (kg/m³)",
      kinematicViscosity25: "运动粘度 @ 25°C (mm²/s)",
      kinematicViscosity40: "运动粘度 @ 40°C (mm²/s)",
      kinematicViscosity80: "运动粘度 @ 80°C (mm²/s)",
      waterClass: "水分类",
      approval: "批准",
    },
    pTypicalApplication: {
      "product-ta-oil": "石油和天然气加工",
      "product-ta-ng-purification": "天然气净化",
      "product-ta-refining": "炼油",
      "product-ta-aps": "沥青加工和储存",
      "product-ta-gtl": "气转液 (GTL)",
      "product-ta-pp-manufacturing": "塑料和聚合物制造",
      "product-ta-shp-manufacturing": "特种热敏聚合物制造",
      "product-ta-sfm": "合成纤维制造",
      "product-ta-plastic-molding": "塑料成型",
      "product-ta-pharmaceutical-manufacturing": "制药",
      "product-ta-chiral-chemical-processes": "手性化学工艺",
      "product-ta-environmental-test-chambers": "环境试验箱",
      "product-ta-specialty-chemical-manufacturing": "特种化学品制造",
      "product-ta-chemical-manufacturing": "化学品制造",
      "product-ta-concentrated-solar-power": "聚光太阳能发电",
      "product-ta-orc": "有机朗肯循环 (ORC)",
      "product-ta-biofuel": "生物燃料制造",
      "product-ta-foodbeverage-processing": "食品饮料加工",
      "product-ta-mdf": "中密度纤维板 (MDF)",
      "product-ta-desalination": "海水淡化",
      "product-ta-htsm": "传热系统维护",
    },
    checkboxHeadline: "选择应用",
    tempRangeHeadline: "温度范围 °C",
    checkboxFilterLabels: {
      heatingAndRecovery: "加热/热回收",
      heatingAndCooling: "加热/冷却",
      cooling: "冷却",
      thermoRegulation: "温度调节",
      foodgrade: "食品级",
    },
    noProductsFound: "我们找不到符合您条件的产品。",
    wrongProductId: {
      title: "未找到产品",
      text: "我们找不到符合您条件的产品。",
      cta: "返回概览",
    },
    contactHeader: {
      slogan: "热油解决方案，值得信赖。",
      contactUs: "联系我们团队",
      phone: "+31 75 70010 15",
      mail: "htf@krahn.eu",
    },
    globalContactForm: {
      headline: "立即找到您的热油解决方案！",
      talkToUs: "立即联系我们",
      mail: "邮件",
      phone: "电话",
      askForCallback: "发送请求",
      dropDownDefault: "我们能帮您什么？",
      dropDown: {
        technicalConsultation: "技术咨询请求",
        requestSample: "油样请求",
        requestOffer: "报价请求",
        requestCallback: "回电请求",
      },
      success: "谢谢！您的消息已成功发送。",
      error: "发生错误。请稍后重试。",
    },
    readMore: "了解更多",
  },
  krahnCeramics: {
    openImage: "打开图片",
  },
  krahnChemie: {
    contact: {
      form: {
        placeholder: {
          message: "输入您的消息",
        },
      },
    },
  },
  scroll: "滚动探索",
  brochure: "宣传册",
  productInformation: "产品信息",
  innovationChallenge: {
    jobs: {
      student: "学生",
      startUpStaff: "有兴趣参加挑战的初创公司员工",
      universityStaff: "大学、学院、研究所或类似机构的研究员/科研人员",
    },
  },
  redirect: {
    title: "发生错误。",
    text: "您是否想要{{}}？",
    buttonLabel: "转到正确页面",
  },
  pageNotFound: {
    title: "找不到此页面 (404)",
    text: "找不到此页面，请返回。",
    buttonLabel: "返回",
  },
  clientArea: {
    successMessage: "您的请求已成功发送。",
    errorMessage: "出现错误。请重试并检查您输入的数据。",
    titleOrder: "您的订单号：",
    titleAlbisNr: "您的Albis订单号：",
    materialName: "材料名称",
    materialNumber: "材料编号",
    dataSource: "数据表",
    sdb: "SDS",
    apz: "COA",
    orderNr: "订单号",
    orderNrLong: "订单号",
    albisNr: "订单号",
    date: "日期",
    name: "姓名",
    documentLabel: "文档",
    backToOverview: "返回订单历史",
    contactBoxTitle: "您的联系人",
    contactBoxAction: "请求回电",
    orderInsight: {
      orderConfirmation: "订单确认",
      orderNumberLabel: "您的订单号：",
      safetySheetLabel: "安全数据表",
      status: "状态：",
      estDeliveryDate: "预计交货日期",
      materialQuantity: "材料数量",
      deliveryDocs: "订单文档",
      albisDeliveries: "Albis交货",
    },
    albisOrderInsight: {
      partOfOrder: "您的订单号：",
      showOrder: "显示订单",
      materialName: "材料名称",
      materialNumber: "材料编号",
      amount: "数量",
      chargeId: "批次号",
      materials: "材料",
    },
    productOrderDialog: {
      title: "重新订购产品",
      description:
        "如果您希望再次订购此产品，请填写下面的表格，相关的Albis同事将与您联系。",
      placeholder: {
        company: "公司",
        useCase: "应用（可选）",
        useCase2: "应用",
        technicalRequirements: "技术要求（可选）",
        technicalRequirements2: "技术要求",
        volume: "体积",
        enterHere: "请输入",
        color: "颜色",
        product: "产品",
      },
      phoneRecallLabel: "请用提供的号码回电给我。",
      moreProductsLabel: "我对其他产品感兴趣。",
      productNameLabel: "选择的产品：",
      notesLabel: "其他评论",
      fileUploadLabel: "上传文档",
      submitBtnLabel: "发送请求",
    },
    productRequestDialog: {
      title: "您在寻找什么样的产品？",
      description:
        "不确定适合您应用的材料？填写下面的表格，让我们的专家协助您做出决定。",
    },
    filter: {
      timeRange: "选择交货时间段",
      refresh: "更新",
    },
    sdbHint: "SDS代表安全数据表",
    apzHint: "COA代表",
    login: {
      title: "登录",
      form: {
        mail: "邮箱*",
        customerNr: "客户编号*",
        orderNr: "订单号（可选）",
        hint: "输入您的订单号，您可以直接转到订单页面。",
      },
      stayLoggedIn: "保持登录状态",
      modal: {
        headline: "您已收到一封邮件",
        text:
          "我们向您的邮箱地址发送了一个魔法链接。如果您打开链接，您将被转到订单概览页面。",
      },
    },
    downloadsHint: "文档下载功能即将推出",
    orderDownloadsHint: {
      label: "文档下载功能目前不可用。",
      link: "或者，请联系我们。",
    },
    moreOrders: "其他待处理订单",
    openOrder: "打开订单",
    error: {
      title: "发生错误。",
      albisIdText: "在此Albis订单号下我们找不到任何内容。请检查您的输入。",
      orderIdText: "在此Albis订单号下我们找不到任何内容。请检查您的输入。",
    },
    upload: {
      title: "上传文档",
      success: "上传成功。",
      hint: "删除文件",
      error: "文件上传不成功。请重试。",
    },
    startCall: {
      title: "联系我们...",
      text:
        "如果您想了解更多关于所选产品的信息，请填写下面的表格，我们的专家将联系您进行讨论。",
      productAdornment: "产品：",
    },
    states: {
      ordered: "已订购",
      confirmed: "已确认",
      scheduled: "已安排",
      shipped: "已发货",
      delivered: "已交付",
      unknown: "未知",
      inProgress: "进行中",
    },
  },
  recyclingForm: {
    polymer: "聚合物",
    mold: "模具",
    filler: "填料",
    color: "颜色",
    amount: "数量（公斤）",
    description: "描述",
    adhesion: "其他粘附物",
    moreInfo: "其他信息",
    wasteDescription: "废料描述",
    quantityPerYear: "年产生量 (t/a)",
    currentUse: "当前用途（销售/处置）",
    targetCustomer: "目标",
    closedLoop: "闭环",
    openLoop: "开环",
    requirementsForFinishedProduct: "成品要求",
    additionalInfo: "更多信息，例如运行时间",
    personalInfo: "您的信息",
    name: "姓名",
    address: "地址",
    email: "邮箱",
    phone: "电话",
    message: "在此输入消息",
    submit: "提交表单",
    save: "保存",
    delete: "删除",
    add: "添加更多废料",
    success: "谢谢！您的消息已发送。",
    errorMocom: "发生错误。请稍后重试或通过info@mocom.eu联系我们。",
    error: "发生错误。请稍后重试或通过info@wipag.com联系我们。",
    notSaved: "尚未保存",
    tooltips: {
      wasteDescription: {
        heading: "必要信息：",
        text:
          "应用（废料产生）\n所含塑料和杂质/粘附物，现有涂层（如油漆）\n填料类型和含量：如玻璃纤维、滑石、碳含量百分比\n状况：组件、边角料、冲压废料、浇道、破碎材料、回收料等。",
      },
      targetCustomer:
        "闭环 = 材料返还给客户（目标成分）\n开环 = 废料接收用于回收和销售",
      requirementsForFinishedProduct: {
        heading: "问题：",
        text:
          "法规要求（如：FDA/UL/NSF/GMP/医疗），清单\n规格（如：机械或流变性能、颜色）",
      },
    },
  },
  floatingButtonWipag: "塑料采购",
  regions: {
    de: "德国",
    at: "奥地利",
    ch: "瑞士",
    uk: "英国",
    ie: "爱尔兰",
    pl: "波兰",
    ro: "罗马尼亚",
    cz: "捷克共和国",
    hu: "匈牙利",
    sk: "斯洛伐克",
    be: "比利时",
    nl: "荷兰",
    lu: "卢森堡",
    it: "意大利",
    fr: "法国",
    es: "西班牙",
    cn: "中国",
    gr: "希腊",
    il: "以色列",
    ru: "俄罗斯",
    se: "瑞典",
    no: "挪威",
    fi: "芬兰",
    dk: "丹麦",
    is: "冰岛",
    bg: "保加利亚",
    lv: "拉脱维亚",
    ee: "爱沙尼亚",
    lt: "立陶宛",
    ba: "波斯尼亚-黑塞哥维那",
    hr: "克罗地亚",
    me: "黑山",
    mk: "马其顿",
    si: "斯洛文尼亚",
    rs: "塞尔维亚",
    cy: "塞浦路斯",
    li: "列支敦士登",
    pt: "葡萄牙",
    xk: "科索沃",
    ua: "乌克兰",
  },
  productArea: {
    selectRegion: "查看您所在地区的可用产品",
    filterApplication: "按应用筛选",
    filterSolution: "按解决方案筛选",
    filterIdea: "按创意筛选",
    filterManufacturer: "按制造商筛选",
    filterLubricants: "按润滑剂筛选",
    filterFuels: "按燃料筛选",
    industry: "选择行业",
    contact: "联系",
    contactButton: "联系详情",
    back: "返回概览",
    characteristics: "产品特性",
    brands: "品牌",
    producer: "生产商",
    application: "应用",
    ideas: "创意",
    lubricants: "润滑剂",
    fuels: "燃料",
    manufacturer: "制造商",
    availability: "可用地区",
    search: "按产品名称搜索",
    searchResults: "搜索结果：",
    showAllProducts: "显示{{}}的所有产品组",
    noResults: "未找到结果",
    noContentMaintained: "该行业似乎没有内容。请稍后再来！",
    resetFilter: "重置筛选",
    allCountries: "选择您的国家",
  },
  jobpages: {
    applyNow: "立即申请！",
    bePartOfTeam: "加入我们的团队：",
    tasks: {
      title: "您的任务",
      main: "主要任务",
      additional: "其他任务",
    },
    profile: {
      title: "您的简介",
      skills: "经验和专业知识",
      personality: "个性",
    },
    offers: "就业市场机会",
    showOffers: "显示{{}}个职位",
    selection: "您的选择",
    filterArea: {
      freeText: "关键词",
      freeTextPlaceholder: "关键词、职位ID",
      department: "职能",
      fallbackDepartment: "所有职能",
      location: "地点",
      fallbackLocation: "所有地点",
      level: "入职级别",
      fallbackLevel: "所有入职级别",
      company: "部门",
      fallbackCompany: "所有部门",
    },
    contract: {
      limited: "临时",
      unlimited: "永久",
    },
    level: {
      starter: "职场新人",
      professional: "专业人士",
      students: "学生",
      graduate: "毕业生",
    },
    pagesPerPage: "每页职位数",
    error: {
      jobDetail: "加载职位详情时发生错误。请稍后重试。",
      jobboard: "加载职位机会时发生错误。请稍后重试。",
    },
    sortingLabel: "排序方式",
    sortingOptions: {
      companyAsc: "公司升序",
      companyDesc: "公司降序",
      titleAsc: "职位标题升序",
      titleDesc: "职位标题降序",
      startOfWorkAsc: "工作开始时间升序",
      startOfWorkDesc: "工作开始时间降序",
      locationAsc: "地点升序",
      locationDesc: "地点降序",
    },
    departments: {
      finance: "财务、会计和控制",
      customerService: "客户服务",
      graphics: "平面设计和建筑",
      distribution: "销售和商务",
      management: "管理和企业发展",
      it: "IT和软件开发",
      law: "法律",
      purchase: "采购、物料管理和物流",
      marketing: "市场营销和广告",
      others: "其他学科",
      projectManagement: "项目管理",
      production: "生产和制造",
      pr: "公关和新闻",
      processPlanning: "工艺规划和质量保证",
      teaching: "教学、研发",
      health: "健康、医疗和社会",
      consulting: "咨询",
      administration: "行政管理",
      engineering: "工程和技术",
      hr: "人力资源",
      productManagement: "产品管理",
      analysis: "分析和统计",
    },
    errorDetails: {
      title: "未找到职位",
      text: "很抱歉，请求的职位广告不再存在。请重新搜索。",
      buttonLabel: "返回",
    },
    errorJobboard: {
      title: "发生错误",
      text: "加载职位机会失败。请稍后重试。",
      buttonLabel: "重试",
    },
    noJobsFound: {
      title: "抱歉，您的搜索没有返回任何结果。",
      text: "更改您的条件并随时重试。",
    },
    position: {
      fulltime: "全职",
      parttime: "兼职",
      intern: "实习",
      freelance: "自由职业",
      owner: "所有者",
      partner: "合伙人",
      board: "监事会成员",
      honorary: "荣誉职位",
      partFull: "兼职/全职",
      trainee: "培训生",
      help: "临时帮助",
      social: "社会承诺",
      apprentice: "学徒",
      training: "学徒制",
      marginal: "边际",
      student: "在职学生",
      temp: "临时/季节性",
      dual: "双重学习",
    },
  },
  a11y: {
    showContent: "激活以显示{{}}的内容",
  },
  altcha: {
    bot: "我不是机器人。",
    error: "出现错误。请确认您不是机器人。",
    verified: "您已通过验证。",
    waitAlert: "请稍等。",
    verifying: "验证进行中...",
    expired: "您的验证已过期。请重试。",
  },
};
